import { useState } from "react";
import { generateAdminInsights } from "@/projects/lib/ai.functions";
import { toast } from "@/projects/lib/toast";

type Props = {
  range: string;
  total: number;
  pending: number;
  assigned: number;
  reward: number;
  notProper: number;
  teachers: number;
  rewardRate: number;
  verificationRate: number;
  topTeachers: { name: string; verified: number }[];
};

function renderMd(md: string) {
  // Ultra-light markdown: **bold**, ## / ### headings, and bullet lines.
  const lines = md.split("\n");
  return lines.map((line, i) => {
    const trimmed = line.trim();
    const lineKey = `md-${i}-${trimmed.slice(0, 24) || "blank"}`;
    if (!trimmed) {
      return <div key={lineKey} className="h-2" />;
    }
    if (trimmed.startsWith("### ")) {
      return (
        <div key={lineKey} className="text-royal mt-2 text-sm font-semibold">
          {trimmed.slice(4)}
        </div>
      );
    }
    if (trimmed.startsWith("## ")) {
      return (
        <div key={lineKey} className="text-royal mt-3 text-sm font-bold">
          {trimmed.slice(3)}
        </div>
      );
    }
    if (trimmed.startsWith("# ")) {
      return (
        <div key={lineKey} className="text-royal mt-3 text-base font-bold">
          {trimmed.slice(2)}
        </div>
      );
    }
    const bullet = /^[-*]\s+/.test(trimmed);
    const content = bullet ? trimmed.replace(/^[-*]\s+/, "") : trimmed;
    const parts = content.split(/(\*\*[^*]+\*\*)/g).map(p =>
      p.startsWith("**") && p.endsWith("**") ? (
        <strong key={`bold:${p}`} className="text-foreground">
          {p.slice(2, -2)}
        </strong>
      ) : (
        <span key={`text:${p}`}>{p}</span>
      )
    );
    return bullet ? (
      <div key={lineKey} className="text-muted-foreground flex gap-2 text-sm">
        <span className="text-gold">◆</span>
        <span>{parts}</span>
      </div>
    ) : (
      <div key={lineKey} className="text-muted-foreground text-sm">
        {parts}
      </div>
    );
  });
}

export function AiInsightsPanel(props: Props) {
  const [text, setText] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      // Build a plain, serializable payload — never pass `props` directly
      // because dev-mode JSX tagging may inject a non-serializable `ref`.
      const payload = {
        range: props.range,
        total: props.total,
        pending: props.pending,
        assigned: props.assigned,
        reward: props.reward,
        notProper: props.notProper,
        teachers: props.teachers,
        rewardRate: props.rewardRate,
        verificationRate: props.verificationRate,
        topTeachers: props.topTeachers.map(t => ({
          name: t.name,
          verified: t.verified,
        })),
      };
      const res = await generateAdminInsights(payload);
      setText(res.text);
    } catch (e) {
      toast.error("Couldn't generate AI insights right now.");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <></>
    // <div className="border-gold/40 from-royal-soft via-card to-gold-soft/40 shadow-card relative overflow-hidden rounded-xl border-2 bg-gradient-to-br p-5">
    //   <div className="bg-gold/20 pointer-events-none absolute -top-8 -right-8 h-40 w-40 rounded-full blur-3xl" />
    //   <div className="bg-royal/20 pointer-events-none absolute -bottom-10 -left-10 h-40 w-40 rounded-full blur-3xl" />

    //   <div className="relative flex flex-wrap items-center justify-between gap-3">
    //     <div className="flex items-center gap-3">
    //       <div className="from-gold to-saffron shadow-soft grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br text-white">
    //         <Sparkles className="h-5 w-5" />
    //       </div>
    //       <div>
    //         <div className="flex items-center gap-2">
    //           <div className="text-royal text-base font-bold">
    //             AI Executive Insights
    //           </div>
    //           <span className="bg-gold text-royal rounded-full px-2 py-0.5 text-[10px] font-bold tracking-wider uppercase">
    //             New
    //           </span>
    //         </div>
    //         <div className="text-muted-foreground text-xs">
    //           Auto-generated summary, risks &amp; recommendations from your
    //           current data.
    //         </div>
    //       </div>
    //     </div>
    //     <Button
    //       onClick={run}
    //       disabled={loading}
    //       className="bg-royal hover:bg-royal/90"
    //     >
    //       {loading ? (
    //         <>
    //           <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Analyzing…
    //         </>
    //       ) : text ? (
    //         <>
    //           <RefreshCw className="mr-2 h-4 w-4" /> Regenerate
    //         </>
    //       ) : (
    //         <>
    //           <Sparkles className="mr-2 h-4 w-4" /> Generate insights
    //         </>
    //       )}
    //     </Button>
    //   </div>

    //   <div className="relative mt-4">
    //     {!text && !loading && (
    //       <div className="border-royal/30 bg-background/60 text-muted-foreground rounded-lg border border-dashed p-4 text-sm">
    //         Click <strong className="text-royal">Generate insights</strong> to
    //         let AI summarize submission trends, spot bottlenecks, and suggest
    //         next actions.
    //       </div>
    //     )}
    //     {loading && (
    //       <div className="space-y-2">
    //         <div className="bg-royal/10 h-3 w-2/3 animate-pulse rounded" />
    //         <div className="bg-royal/10 h-3 w-11/12 animate-pulse rounded" />
    //         <div className="bg-royal/10 h-3 w-4/5 animate-pulse rounded" />
    //         <div className="bg-royal/10 h-3 w-9/12 animate-pulse rounded" />
    //       </div>
    //     )}
    //     {text && (
    //       <div className="bg-background/70 space-y-1 rounded-lg border p-4 backdrop-blur">
    //         {renderMd(text)}
    //       </div>
    //     )}
    //   </div>
    // </div>
  );
}
